import { dateToShow, dateToMysql } from '@/helpers/dates'
import moment from 'moment'
import { success } from '@/utils/alert'

const prepareSave = lock => {
  lock.date_start = dateToMysql(lock.date_start) + ' ' + lock.time_start
  lock.date_end = dateToMysql(lock.date_end) + ' ' + lock.time_end

  delete lock.time_start
  delete lock.time_end
  delete lock.type

  return lock
}

const prepareShow = lock => {
  lock.time_start = moment(lock.date_start).format('HH:mm')
  lock.time_end = moment(lock.date_end).format('HH:mm')

  lock.date_start = dateToShow(lock.date_start)
  lock.date_end = dateToShow(lock.date_end)

  return lock
}

export default {
  prepareShow,
  prepareSave,
  afterCreated () {
    this.wasRaised = true
    this.show = true
  },
  afterUpdated () {
    success('Bloqueio alterado com sucesso.')
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/form/resources/methods.js